// Вход: экран «Войти через Google», экран «нет кабинета» (вошёл не тем аккаунтом) и выход.
// В приложении для Android (APK) Google открывается в браузере телефона — через мостик window.Praktika.
import { setAccessHandler, type ApiError } from './api.ts';
import { $, esc } from './dom.ts';
import { closeSheet } from './sheet.ts';
import { S } from './state.ts';

function screen(html: string): void {
  closeSheet();
  $('#nav').hidden = true;
  $('#fab').hidden = true;
  $('#app').innerHTML = '<div class="p-title"><span class="t">Практика</span></div>' + html;
}

// Войти или дать Google разрешение на календарь: в APK — его мостиком, на сайте — переходом на страницу Google.
export function googleAuth(what: 'login' | 'calendar' = 'login'): void {
  const P = window.Praktika;
  if (what === 'login' && P?.login) { P.login(); return; }
  if (what === 'calendar' && P?.auth) { P.auth('calendar', S?.email ?? ''); return; }
  location.href = what === 'calendar' ? '/auth/google?for=calendar' : '/auth/google';
}

export function renderLogin(): void {
  screen('<div class="p-sum">Войдите через Google — тем аккаунтом, в календаре которого ваши сессии.</div>' +
    '<div class="btnrow"><button class="btn pri" data-login>Войти через Google</button></div>' +
    '<p class="p-note">Данные хранятся на сервере «Практики», не в Google.</p>');
  $('[data-login]').onclick = () => googleAuth();
}

export function renderNoAccess(email: string): void {
  screen('<div class="p-sum">Для <b>' + esc(email) + '</b> кабинета пока нет. Попросите того, кто дал вам ' +
    'приложение, добавить этот адрес, или войдите другим аккаунтом.</div>' +
    '<div class="btnrow"><button class="btn sec" data-other>Войти другим аккаунтом</button></div>');
  $('[data-other]').onclick = () => void logout('/auth/google');
}

// Выйти: сервер забывает вход; в APK — ещё и его окно начинает с экрана входа.
export async function logout(then = '/'): Promise<void> {
  try { await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' }); } catch { /* всё равно на вход */ }
  const P = window.Praktika;
  if (P?.logout) {
    P.logout();
    if (then.startsWith('/auth/google')) googleAuth();
    return;
  }
  location.href = then;
}

setAccessHandler((e: ApiError) => { if (e.code === 'no_practice') renderNoAccess(e.email); else renderLogin(); });
